// @ts-nocheck

// TODO refactor this

import React from "react";
import { WidgetProps } from "react-jsonschema-form";
import { Select } from "../Select/Select";
/**
 * This is a silly limitation in the DOM where option change event values are
 * always retrieved as strings.
 */

type Selectpros = WidgetProps & {
  multiple: boolean;
  options: any;
};

interface reactFormOption {
  enumOptions: [
    {
      value: string;
      label: string;
    }
  ];
  enumDisabled: [
    {
      value: string;
      label: string;
    }
  ];
}

function processValue(value: any) {
  return value;
}

function getValue(value: any, multiple: boolean, options: any) {
  console.log("getValue", value, multiple, options);
  if (multiple) {
    const filtered = options.filter((opt: any) => value.includes(opt.value));
    console.log("getValue returned:", filtered);
    return filtered;
  } else {
    const filtered = options.filter((opt: any) => opt.value === value);
    console.log("getValue returned:", filtered);

    return filtered;
  }
}

function onChangeWrapper(
  originalOnChange: any,
  value: any,
  action: any,
  multiple: boolean
) {
  console.log("onChangeWrapper", value, action, multiple);
  if (multiple) {
    const selected = value.map((opt: any) => opt.value);
    console.log("selected", selected);
    originalOnChange(selected);
    return;
  }
  console.log("selected", value.value);

  originalOnChange(value.value);
}

function CustomSelect(props: Selectpros) {
  const {
    schema,
    id,
    options,
    value,
    required,
    disabled,
    readonly,
    multiple,
    autofocus,
    onChange,
    onBlur,
    onFocus,
    placeholder,
  } = props;
  const { enumOptions, enumDisabled } = options as reactFormOption;
  const emptyValue = multiple ? [] : "";
  const selectOptions = [] as any;

  enumOptions &&
    enumOptions.forEach(option => {
      selectOptions.push(option);
    });
  enumDisabled &&
    enumDisabled.forEach(option => {
      selectOptions.push({ ...option, isDisabled: true });
    });
  console.log("PROPS", props);
  return (
    <Select
      id={id}
      value={getValue(value, multiple, selectOptions)}
      autoFocus={autofocus}
      isDisabled={disabled}
      onChange={(value, action) =>
        onChangeWrapper(onChange, value, action, multiple)
      }
      isSearchable={true}
      name="color"
      isMulti={multiple}
      options={selectOptions}
      placeholder={placeholder}
    />
  );
}

export default CustomSelect;
